import {
  defineSaleProgress,
  hasAddress,
  isSaleCreated,
  isSaleStarted,
  type ProgressSaleData,
  type SaleStatus,
} from '../saleProgress'
import type { ScriptSteps } from '../scripts/blocks/stages'

interface MeilleurTauxData extends ProgressSaleData {
  scriptSteps?: ScriptSteps | null
}

const TIMELINE = 'additionalSales:pulse.timeline.'

export const isSimulatorOpened = (data: MeilleurTauxData) => !!data.scriptSteps?.extLink

export default defineSaleProgress<MeilleurTauxData>({
  kind: 'lead',
  steps: [
    { key: 'address', label: `${TIMELINE}address`, done: hasAddress },
    { key: 'link_opened', label: `${TIMELINE}link_opened`, done: isSimulatorOpened },
    { key: 'created', label: `${TIMELINE}lead_created`, done: isSaleCreated },
  ],
  status: (data, steps): SaleStatus => {
    if (steps[steps.length - 1]?.state === 'done') return 'signed'
    if (isSaleStarted(data) || steps.some(step => step.state === 'done')) return 'progress'

    return 'new'
  },
})
